import React from "react";
import { Box, Text } from "@origin-digital/ods-core";

export const AddressSection = ({ address }: { address: string }) => {
  return (
    <Box
      paddingLeft="xlarge"
      data-role="section"
      id="detail-template-address-section"
    >
      <Text data-role="value" data-id="address">
        {address}
      </Text>
    </Box>
  );
};
